import AWS from 'aws-sdk';
import { IAdminRepository } from './admin.types';
import { Auth } from "@aws-amplify/auth";
import {
    AdminDisableUserResponse,
    ListGroupsResponse,
    ListUsersInGroupResponse,
    ListUsersResponse,
    // UsersListType 
} from 'aws-sdk/clients/cognitoidentityserviceprovider';
import awsconfig from "../../aws-exports";

const UserPoolId = awsconfig.aws_user_pools_id;
export class AdminAPIRepository implements IAdminRepository {
    async listUsersInGroup(groupName: string, nextToken?: string): Promise<ListUsersInGroupResponse> {
        const credentials = await Auth.currentCredentials();
        const cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider({
            region: "ap-southeast-1",
            accessKeyId: credentials.accessKeyId,
            secretAccessKey: credentials.secretAccessKey,
            sessionToken: credentials.sessionToken,
        });
        const params = {
            GroupName: groupName, /* required */
            UserPoolId, /* required */
            // Limit: 3,
            NextToken: nextToken,
        };
        return await cognitoidentityserviceprovider.listUsersInGroup(params).promise();
    }
    async listGroups(): Promise<ListGroupsResponse> {
        const credentials = await Auth.currentCredentials();
        const cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider({
            region: "ap-southeast-1",
            accessKeyId: credentials.accessKeyId,
            secretAccessKey: credentials.secretAccessKey,
            sessionToken: credentials.sessionToken,
        });
        const params = {
            UserPoolId, /* required */
            // Limit: 'NUMBER_VALUE',
            // NextToken: 'STRING_VALUE'
        };
        return await cognitoidentityserviceprovider.listGroups(params).promise();

    }
    async adminAddUserToGroup(username: string, groupName: string): Promise<unknown> {
        const credentials = await Auth.currentCredentials();
        const cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider({
            region: "ap-southeast-1",
            accessKeyId: credentials.accessKeyId,
            secretAccessKey: credentials.secretAccessKey,
            sessionToken: credentials.sessionToken,
        });
        const params = {
            UserPoolId, /* required */
            Username: username, /* required */
            GroupName: groupName, /* required */
        };
        return await cognitoidentityserviceprovider.adminAddUserToGroup(params).promise();
    }
    async adminRemoveUserFromGroup(username: string, groupName: string): Promise<unknown> {
        const credentials = await Auth.currentCredentials();
        const cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider({
            region: "ap-southeast-1",
            accessKeyId: credentials.accessKeyId,
            secretAccessKey: credentials.secretAccessKey,
            sessionToken: credentials.sessionToken,
        });
        const params = {
            UserPoolId, /* required */
            Username: username, /* required */
            GroupName: groupName, /* required */
        };

        return await cognitoidentityserviceprovider.adminRemoveUserFromGroup(params).promise();
    }
    async listUser(nextToken?: string): Promise<ListUsersResponse> {
        const credentials = await Auth.currentCredentials();
        const cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider({
            region: "ap-southeast-1",
            accessKeyId: credentials.accessKeyId,
            secretAccessKey: credentials.secretAccessKey,
            sessionToken: credentials.sessionToken,
        });
        const params = {
            UserPoolId, /* required */
            // AttributesToGet: [
            //     'STRING_VALUE',
            //     /* more items */
            // ],
            // Filter: 'STRING_VALUE',
            // Limit: 1,
            PaginationToken: nextToken,
        };
        // await cognitoidentityserviceprovider.listUsers(params, function (err, data) {
        //     if (err) console.log(err, err.stack); // an error occurred
        //     else console.log(data);           // successful response
        // });

        return await cognitoidentityserviceprovider.listUsers(params).promise();
    }

    async adminDisableUser(username: string): Promise<AdminDisableUserResponse> {
        const credentials = await Auth.currentCredentials();
        const cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider({
            region: "ap-southeast-1",
            accessKeyId: credentials.accessKeyId,
            secretAccessKey: credentials.secretAccessKey,
            sessionToken: credentials.sessionToken,
        });
        const params = {
            UserPoolId, /* required */
            Username: username /* required */
        };

        const data = await cognitoidentityserviceprovider.adminDisableUser(params).promise();
        // console.log(data);
        return data
    }

    async adminEnableUser(username: string): Promise<AdminDisableUserResponse> {
        const credentials = await Auth.currentCredentials();
        const cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider({
            region: "ap-southeast-1",
            accessKeyId: credentials.accessKeyId,
            secretAccessKey: credentials.secretAccessKey,
            sessionToken: credentials.sessionToken,
        });
        const params = {
            UserPoolId, /* required */
            Username: username /* required */
        };

        const data = await cognitoidentityserviceprovider.adminEnableUser(params).promise();
        // console.log(data);
        return data
    }

    async adminListGroupsForUser(username: string): Promise<AWS.CognitoIdentityServiceProvider.AdminListGroupsForUserResponse> {
        const credentials = await Auth.currentCredentials();
        const cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider({
            region: "ap-southeast-1",
            accessKeyId: credentials.accessKeyId,
            secretAccessKey: credentials.secretAccessKey,
            sessionToken: credentials.sessionToken,
        });
        const params = {
            UserPoolId, /* required */
            Username: username /* required */
        };

        const data = await cognitoidentityserviceprovider.adminListGroupsForUser(params).promise();
        // console.log(data);
        return data
    }

    async adminUpdateUserAttributes(username: string, name: string, value: string): Promise<void>{
        const credentials = await Auth.currentCredentials();
        const cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider({
            region: "ap-southeast-1",
            accessKeyId: credentials.accessKeyId,
            secretAccessKey: credentials.secretAccessKey,
            sessionToken: credentials.sessionToken,
        });
        const params = {
            UserAttributes: [
                {
                    Name: name,
                    Value: value,
                }
            ],
            UserPoolId, /* required */
            Username: username /* required */
        };

        const data = await cognitoidentityserviceprovider.adminUpdateUserAttributes(params).promise();
        // console.log(data);
        // return data
    }
}